import { postToHost } from "./native";
import type { AttemptEnvelope } from "../types";

/**
 * Standard exit path for every runner. Posts to both `attempt` (the host
 * forwards to Nexus) and `haptic` (the host vibrates accordingly).
 *
 * The host is the source of truth: it re-emits to the server with the
 * learner's bearer token attached. The runner never holds a token.
 */
export function postAttempt(envelope: AttemptEnvelope): void {
  postToHost("attempt", envelope);
  postToHost("haptic", {
    style: envelope.passed ? "success" : "error",
  });
}

/**
 * Creates a fresh client_event_id. Uses crypto.randomUUID when available;
 * otherwise a Math.random fallback (only happens on truly ancient WebViews).
 */
export function newClientEventId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback (RFC 4122 §4.4 — pseudo-random) — fine for idempotency keys
  // since the server validates uniqueness anyway.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
